// extracted by mini-css-extract-plugin
export default {"linkButton":"aojULllFdU5ZJtq5QBvX"};